//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { EmailSender } from './Enums';

export class SendEmailInputItem extends ItemBase {
    RecipientIDs: string[] = [];
    ExtraRecipients: string[] = [];
    TargetSendDate: string | null = null;
    SubjectWithPlaceholders: string | null = null;
    BodyWithPlaceholders: string | null = null;
    AttachmentStorageTokens: string[] = [];
    EmailSender: EmailSender = EmailSender.Teacher;
    BCCSender: boolean = false;

    constructor(initializer?: Partial<SendEmailInputItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "SendEmailInputItem";
}
